import { FC } from "react";

import { Icon } from "components/atoms/Icon/Icon";
import { IconType } from "@types";
import s from "./SubmitButton.module.scss";

interface Props {
  value: string;
  disabled?: boolean;
  isLoading?: boolean;
  icon?: IconType;
}

export const SubmitButton: FC<Props> = (props) => {
  const { value, disabled, isLoading, icon } = props;

  return (
    <button
      type="submit"
      className={s.SubmitButton}
      value={value}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {isLoading && icon ? (
        <Icon name={icon} size="xl" color="white" />
      ) : (
        <>
          {icon && <Icon name={icon} size="xl" color="white" />}
          <span className={s.ButtonText}>{value}</span>
        </>
      )}
    </button>
  );
};
